export default {
    fund: [{
            "title": "以下属于基金的绝对收益归因的是（　　）。",
            "questions": "I．考查各个因素对基金总收益的贡献<br>II．分析资产配置效应与证券选择效应<br>III．分析基金业绩或业绩比较基准的原因<br>IV．假设在考察区间内没有交易行为，将每个证券的贡献为自身的收益率乘以其初始权重",
            "question": "A．III、IV\nB．I、IV\nC．II\nD．I、II、III",
            "answer": "B",
            "explain": "绝对收益是证券或投资组合在一定时间区间内所获得的回报，测量的是证券或证券投资组合的增值或贬值，常用持有区间收益率、现金流和时间加权收益率、平均收益率以及基金收益率来衡量；而相对收益归因分析主要针对的是相对收益，又叫超额收益，存在比较的对象。在绝对收益归因中，我们考察在特定区间内，每个证券和每个行业如何贡献到组合的整体收益。"
        },
        {
            "title": "小王在银行间债券市场交易，需要合规并经审批的金融机构法人代为办理债券结算业务，所体现的交易制度为（　　）。",
            "question": "A．公开市场一级交易商制度\nB．结算代理制度\nC．会员管理制度\nD．做市商制度",
            "answer": "B",
            "explain": "银行间债券市场的交易制度包括：公开市场一般交易商制度、做市商制度、结算代理制度。①结算代理制度是指经中国人民银行批准可以开展结算代理业务的金融机构法人，受市场其他参与者的委托，为其办理债券结算业务的制度。②做市商制度是指债券市场上，由具有一定实力和信誉的市场参与者作为特许交易商，不断向投资者报出某些特定债券的买卖价格，双向报价并在该价位上接受投资者的买卖要求，以其自有资金和债券与投资者进行交易的制度。"
        },
        {
            "title": "交易员不能有效履行对基金经理交易指令的监督、复核职责，这会产生（　　）。",
            "question": "A．市场风险\nB．操作风险\nC．投资风险\nD．信用风险",
            "answer": "B",
            "explain": "投资交易中的操作风险是指由于人员、流程、系统或外部因素带来的交易失误。其原因包括：人为错误、电脑系统故障、工作程序和内部控制不当等等，它会导致基金资产或基金公司财产损失，或基金公司声誉受损，受到监管部门处罚等的风险。“交易员不能有效履行对基金经理交易指令的监督、复核职责”属于内部控制不当导致的操作风险。"
        },
        {
            "title": "关于基金估值基本原则，以下表述正确的是（　　）。",
            "question": "A．如经济环境发生重大变化，但使潜在估值调整对前一估值日的资产净值影响仅在0.5%的，可以不对估值进行调整\nB．采用估值技术确定投资品种公允价值时，可以先使用不可观察输入值\nC．对于估值日无报价且交易日后未发生影响公允价值计量的重大事件的投资品种，应采用估值技术确定公允价值\nD．对存在活跃市场且能够获取相同资产或者负债报价的投资品种，估值日有报价的，除例外情况外，应采用该报价确定公允价值",
            "answer": "D",
            "explain": "如经济环境发生重大变化，但使潜在估值调整对前一估值日的资产净值影响在0.25%以上的，应当对估值进行调整并确定公允价值。对存在活跃市场且能够获取相同资产或者负债报价的投资品种，估值日有报价的，除例外情况外，应采用该报价确定公允价值。对于估值日无报价且最近交易日后未发生影响公允价值计量的重大事件的投资品种，应采用最近交易日的报价确定公允价值。采用估值技术确定投资品种公允价值时，应优先使用可观察输入值，只有无法获取相关资产或负债可观察值或取得不切实可行的情况下，才可以使用不可观察输入值。"
        },
        {
            "title": "关于QDII基金的估值负责人，以下表述错误的是（　　）。",
            "question": "A．QDII基金的托管人负有估值复核责任\nB．QDII基金的资产估值负责主体是基金托管人\nC．QDII基金的托管人应当确保基金的份额净值符合有关法律法规的规定\nD．QDII基金的托管人应当确保基金的份额净值按照基金合同规定的方法计算",
            "answer": "B",
            "explain": "基金托管人在履行执行时应确保基金的份额按照有关法律法规、基金合同和集合资产管理合同规定的方法进行计算。在实践中，基金管理公司是QDII基金的会计核算和资产估值的责任主体，托管人负有复核责任。"
        },
        {
            "title": "关于机构投资者的总体特征，以下表述正确的是（　　）。",
            "question": "A．常常需要借助基金销售服务机构进行投资\nB．资金量较小\nC．风险承受能力较弱\nD．投资管理相对专业",
            "answer": "D",
            "explain": "相比个人投资者，机构投资者资金实力更为雄厚，抗风险能力更强，且投资能力更为专业。"
        },
        {
            "title": "对于一个股票投资组合而言，以下因素中构成系统性风险的是（　　）。",
            "question": "A．某上市公司董事长涉嫌犯罪\nB．某上市公司曝出产品质量危机\nC．某个行业景气度的不确定性\nD．宏观经济环境的不确定性",
            "answer": "D",
            "explain": "系统性风险是由经济环境因素的变化引起的整个金融市场的不确定性的加强，其冲击是属于全面性的，主要包括经济增长、利率、汇率与物价波动以及政治因素的干扰等。故本题选D。"
        }, {
            "title": "利润表的起点和终点分别为（　　）和（　　）。",
            "question": "A．营业收入，净利润\nB．营业收入，营业成本\nC．营业收入，所得税费用\nD．营业收入，营业利润",
            "answer": "A",
            "explain": "利润表的起点是公司在特定会计期间的收入，然后减去与收入相关的成本费用，利润表的终点是净利润。利润表的基本结构是收入减去成本和费用等于利润(或盈余)。"
        },
        {
            "title": "有关场内证券交易中的大宗交易，以下表述正确的是（　　）。",
            "question": "A．大宗交易是指单个投资人单日对单个证券交易累计量达到一定数额的证券买卖\nB．上海证券交易所和深圳证券交易所的大宗交易申报时间有所差异\nC．证券交易所调整大宗交易的最低限额须经证监会审批同意\nD．大宗交易平台可以接受当日停牌股票的交易申报",
            "answer": "B",
            "explain": "大宗交易是指单笔数额较大的证券买卖。按照规定，证券交易所可以根据市场实际情况调整大宗交易的最低限额。平台不接受停牌股票的有关申报，沪深两市接受大宗交易的时间有所不同。上海证券交易所接受大宗交易的时间为每个交易日9:30-11:30、13:00-15:30。但如果在交易日15:00前处于停牌状态的证券，则不受理其大宗交易的申报。每个交易日15:00-15:30，交易所交易主机对买卖双方的成交申报进行成交确认。"
        },
        {
            "title": "基金会计的核算主体为（　　）。",
            "question": "A．企业\nB．基金管理人\nC．基金托管人\nD．证券投资基金",
            "answer": "D",
            "explain": "会计主体是会计为之服务的特定对象。企业会计核算以企业为会计核算主体，基金会计则以证券投资基金为会计核算主体。基金管理公司是证券投资基金会计核算的责任主体，对所管理的基金应当以每只基金为会计核算主体，同时，由于基金托管人对基金管理公司计算的基金资产净值以及基金业绩报告负有复核责任，因此基金托管人也需要对所托管的证券投资基金进行会计核算，并将有关结果同基金管理公司相核对；基金会计的责任主体是对基金进行会计核算的基金管理公司和基金托管人，其中前者承担主会计责任。我国基金的会计年度为公历每年1月1日至12月31日。基金核算以人民币为记账本位币，以人民币元为记账单位。"
        },
        {
            "title": "根据GIPS收益率计算的相关规定，自2006年1月1日起，投资管理机构必须至少（　　）一次计算组合群的收益；自2010年1月1日起，必须至少（　　）一次计算组合群收益。",
            "question": "A．每季度，每半年\nB．每季度，每月\nC．每月，每半年\nD．每月，每季度",
            "answer": "B",
            "explain": "GIPS属于非强制的标准；投资管理机构使用GIPS标准进行披露时，不用同时遵守它提供的两套标准。自2006年1月1日起，投资管理机构必须至少每季度一次计算组合群的收益，并使用个别投资组合的收益以资产加权计算。自2010年1月1日起，必须至少每月一次计算组合群收益，并使用个别投资组合的收益以资产加权计算。故本题选B。"
        },
        {
            "title": "某投资者委托香港经纪商，通过联交所设立的证券交易服务公司，向上交所进行申报，买卖规定范围内的股票行为叫（　　）。",
            "question": "A．深股通\nB．港股通\nC．沪股通\nD．债券通",
            "answer": "C",
            "explain": "沪港通分为沪股通和港股通两个部分。所谓沪股通，就是投资者委托香港经纪商，经由香港联合交易所设立的证券交易服务公司，向上海证券交易所进行申报（买卖盘传递），买卖规定范围内的上海证券交易所上市的股票。而港股通就是投资者委托内地证券服务公司，经由上海证券交易所设立的证券交易服务公司，向香港联合交易所进行申报（买卖盘传递），买卖规定范围内的香港联合交易所上市的股票。目前，沪港通下的港股通标的包括恒生综合大型股指数成分股、恒生综合中型股指数成分股和同时在上交所、港交所上市的A+H股公司股票。"
        },
        {
            "title": "关于债券的当期收益率与到期收益率，以下表述正确的是（　　）。",
            "questions": "I．当期收益率仅考虑当期利息收入<br>II．当期收益率没有考虑债券投资所获得的资本利得<br>III．到期收益率衡量的是买入并持有至到期的收益率<br>IV．当期收益率是单利，到期收益率是复利",
            "question": "A．I、III、IV\nB．I、II、III、IV\nC．II、III、IV\nD．I、II、IV",
            "answer": "B",
            "explain": ""
        }, {
            "title": "关于银行间债券市场结算类型，以下表述错误的是（　　）。",
            "question": "A．净额结算适用于交易所撮合交易模式和做市商机制发达的场外市场\nB．做市商需对全额结算的完成提供担保\nC．结算机构可以在净额结算中担当中央对手方\nD．全额结算适用于高度自动化系统的规模较大的市场",
            "answer": "B",
            "explain": "根据债券交易和结算的相互关系，债券结算可分为全额结算和净额结算两种类型。净额结算方式与全额结算方式的主要差异在于对交易进行差额结算和逐笔结算。"
        },
        {
            "title": "混合型基金投资风险管理的主要手段是（　　）。",
            "question": "A．控制投资者结构\nB．选择合适的交易场所\nC．分散投资\nD．调整股票、债券等大类资产的配置比例",
            "answer": "D",
            "explain": "由于混合基金的股票仓位比股票型基金和债券型基金的要灵活，针对其的风险管理也更多样化，具体可根据基金当时的股票仓位和面临的主要投资风险进行控制。目前混合基金的股票仓位灵活，使得基金在市场下跌时有了规避系统性风险的可能。混合基金股票仓位较高时，可参照股票型基金，对基金行业集中度、持股集中度等风险指标进行监控；在债券仓位较高时，可参照债券型基金，侧重对基金组合久期、持债集中度等风险。"
        },
        {
            "title": "以下私募股权投资基金投资者中，对私募股权基金承担无限连带责任的是（　　）。",
            "question": "A．公司型基金的投资者\nB．合伙型基金的普通合伙人\nC．信托型基金的投资者\nD．合伙型基金的有限合伙人",
            "answer": "B",
            "explain": "私募股权投资基金通常分为有限合伙制、公司制和信托制三种组织结构。在有限合伙制中，普通合伙人主要代表整个私募基金对外行使各种权利，对私募股权基金承担无限连带责任，收入来源是基金管理费和盈利分红，有限合伙人则负责出资，并以其出资额为限，承担连带责任。"
        },
        {
            "title": "2017年末某基金可供分配利润为1.55亿元，未分配利润未实现部分为-3000万元，则2017未分配利润已实现部分（　　）。",
            "question": "A．1.25亿元\nB．3000万元\nC．1.55亿元\nD．1.85亿元",
            "answer": "D",
            "explain": "期末可供分配利润，该指标是指期末可供基金进行利润分配的金额，为期末资产负债表中未分配利润与未分配利润中已实现部分的较低数。期末未分配利润=期末未分配已实现利润+期末未分配未实现利润。本题中期末未分配利润的未实现部分为-3000万元，为负数，所以期末可供分配利润为1.55-(-0.3)=1.85亿元。"
        },
        {
            "title": "下列属于基金公司在交易执行环节可能存在的风险的有（　　）。",
            "questions": "I．未践行最佳执行原则，交易效率低或差错率高<br>II．交易系统未经严格测试论证，系统缺陷造成交易失误<br>III．交易价格显著偏离公允价值<br>IV．基金经理对宏观经济预判失误",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、II、III\nD．I、III",
            "answer": "C",
            "explain": "基金公司在交易执行环节可能存在的风险包括：(1) 未践行最佳执行原则，交易效率低或差错率高；"
        },
        {
            "title": "采用完全复制法来构造股票投资组合的股型指数基金,以下表述正确的是（　　）。",
            "question": "A．研究成本较低\nB．不需要调仓换股\nC．股票仓位为100%\nD．不存在跟踪误差",
            "answer": "A",
            "explain": "完全复制是指通过购买所有指数成分证券，完全按照成分证券在指数中的权重配置资金，并在指数结构调整时也同步调整来实现与指数完全相同的收益率。“不需要调仓换股”错误。这种方法简单明了，跟踪误差较小“不存在跟踪误差”错误，在理论上，完全复制是最好的策略，但完全复制实际操作难度较大。采用完全复制法来构造股票投资组合的股票型指数基金，股票仓位一般不低于90%，“股票仓位为100%”错误，故本题选A。"
        },
        {
            "title": "与基金利润有关的财务指标不包括（　　）。",
            "question": "A．本期已实现收益\nB．基金总份额\nC．本期利润\nD．期末可供分配利润",
            "answer": "B",
            "explain": "与基金利润有关的财务指标包括本期利润、本期已实现收益、期末可供分配利润、未分配利润。"
        }, {
            "title": "2017年10月16日(周一)，某开放式基金估值表中的明细项目如下：银行存款10000万元，股票市值150000万元，应收股利1000万元，预付200万，应付费用400万元、应付证券清算款2400万元，基金份额为100000万份。当日该基金份额净值是（　　）元。",
            "question": "A．1.6\nB．1.62\nC．1.58\nD．1.55",
            "answer": "C",
            "explain": "基金份额净值是计算投资者申购基金份额、赎回资金金额的基础，也是评价基金投资业绩的基础指标之一。基金资产净值=基金资产-基金负债=10000万+150000万+1000万-200万-400万-2400万=158000万元，基金份额净值=基金资产净值/基金份额=158000万元/100000万份=1.58元。"
        },
        {
            "title": "张大爷在周五成功申购了某场外货币基金，又在下周四成功赎回了该基金，除周六日外没有法定节假日，张大爷可以享受分红的天数是（　　）天。",
            "question": "A．4\nB．6\nC．5\nD．3",
            "answer": "A",
            "explain": "当日申购的基金份额自下一个工作日起享有基金的分配权益，当日赎回的基金份额自下一个工作日起不享有基金的分配权益。具体而言，货币市场基金每周五进行分配时，将同时分配周六和周日的利润；每周一至周四进行分配时，则仅对当日利润进行分配。投资者于周五申购或转换转入。"
        },
        {
            "title": "以下统计量中，描述统计样本偏离其均值程度的是（　　）。",
            "question": "A．方差\nB．中位数\nC．分位数\nD．相关系数",
            "answer": "A",
            "explain": "方差和标准差是估计资产实际收益率与期望收益率之间可能偏离程度的测度方法。故本题选择“方差”。中位数是用来衡量数据取值的中等水平或一般水平的数值。"
        },
        {
            "title": "某资产管理机构要其下属部门每月初提交上月旗下所管理组合的绩效评估报告，这种行为属于投资组合管理的（　　）步骤。",
            "question": "A．反馈\nB．规划\nC．执行\nD．查询",
            "answer": "A",
            "explain": "具体而言，投资组合管理通常包括以下三个基本步骤：（一）规划。确定并量化投资者的投资目标和投资限制；制定投资政策说明书；形成资本市场预期；建立战略资产配置。（二）执行。投资执行是投资规划的实现，在执行阶段，投资经理会结合投资组合的既定目标、资本市场预期和"
        },
        {
            "title": "证券投资基金在投资过程中获得的收入可能会涉及所得税的是（　　）。",
            "question": "A．债券差价收入\nB．股票差价收入\nC．债券利息收入\nD．买入返售金融资产收入",
            "answer": "D",
            "explain": "对证券投资基金从证券市场中取得的收入，包括买卖股票、债券的差价收入，股权的股息、红利收入，债券的利息收入及其他收入，暂不征收企业所得税。“买入返售金融资产收入”可能会涉及到代扣个人所得税的情况。"
        },
        {
            "title": "关于短期回购协议，以下表述正确的是（　　）。",
            "question": "A．回购协议是一种信用贷款，不需要提交抵押品\nB．个人投资者只能在场内交易市场即上交所和深交所参与回购\nC．由于回购协议中的抵押品一般是国债，因此交易过程中不存在信用风险\nD．目前国内回购市场以买断式回购为主要交易品种",
            "answer": "B",
            "explain": "回购协议是一种证券抵押协议，抵押品以国债为主，交易过程中仍然存在信用风险，表现为两个方面：①当短期利率大幅上涨时，抵押品价值大幅下跌，正回购无法按照约定价格赎回债券；②当短期利率大幅下跌时，抵押品价值大幅上涨，逆回购方不愿意按照约定价格将抵押债券转让。"
        },
        {
            "title": "关于利息率，以下说法错误的是（　　）。",
            "question": "A．是人民银行公布的存贷款利率\nB．是资金的增值同投入资金的价值之比\nC．是衡量资金增值量的基本单位\nD．可以分成名义利率和实际利率",
            "answer": "A",
            "explain": "利息率简称利率，是资金的增值同投入资金的价值之比，是衡量资金增值量的基本单位。按照不同的标准可以划分出多种利率类别，其中，按债权人取得报酬的情况，可以将利率分成为实际利率和名义利率。"
        },
        {
            "title": "衡量基金绩效的指标有多种，其中属于风险调整收益指标的是（　　）。",
            "question": "A．平均收益率\nB．年化收益率\nC．特雷诺比率\nD．加权收益率",
            "answer": "C",
            "explain": "考虑风险调整的基金业绩评估方法：夏普比率、特雷诺比率、詹森α。"
        }, {
            "title": "基金管理公司的最高投资决策机构为（　　）。",
            "question": "A．基金经理办公会\nB．基金管理公司董事会\nC．基金管理公司股东会\nD．投资决策委员会",
            "answer": "D",
            "explain": "投资决策委员会是基金公司管理基金投资的最高决策机构，由各个基金公司自行设立，是非常设的议事机构。投资决策委员会应在遵守国家有关法律法规、公司规章制度的前提下，对基金公司各项重大投资活动进行管理，审定公司投资管理制度和业务流程，并确定不同管理级别的操作权限。"
        },
        {
            "title": "已知某公司的净资产收益率为15%，销售利润率是5%，总资产周转率是1，那么该公司的负债权益比是（　　）。",
            "question": "A．0.5\nB．0.16\nC．1.5\nD．2",
            "answer": "D",
            "explain": "净资产收益率=销售利润率*总资产收转率*权益乘数。15%=5%*1*权益乘数；得出权益乘数=3；负债权益比=负债/所有者权益=（资产-所有者权益）/所有者权益=权益乘数-1=3-1=2。"
        },
        {
            "title": "会计师在审计某公司2016年底的财务报表时发现该公司将其所得税费用计算错误，多计提了所得税费用，会计师调整后该公司的利息倍数将会（　　）。",
            "question": "A．无法判断\nB．变小\nC．变大\nD．不变",
            "answer": "D",
            "explain": "EBIT=净利润+利息+税，利息保障倍数=EBIT/=息税前净利润/利息=（净利润+利息+税）/利息，多计提了所得税费用，不影响税前净利润，只影响税后净利润，因此利息保障倍数不变。"
        },
        {
            "title": "关于投资者效用函数画出的无差异曲线，以下表述正确的是（　　）。",
            "question": "A．风险厌恶程度高的投资者与风险厌恶程度低的投资者相比,其无差异曲线更加陡峭\nB．同一条无差异曲线上的点所代表的效用水平并不必然相同\nC．不同的无差异曲线也可以代表相同的效用水平\nD．风险厌恶的投资者的无差异曲线是从左上方向右下方倾斜的",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "债券的到期收益率的影响因素，包括（　　）。",
            "questions": "I．票面利率<br>II．债券市场价格<br>III．债券的计息方式<br>IV．市场无风险收益率<br>V．利息再投资收益率",
            "question": "A．I、II、III、V\nB．I、II、III、IV\nC．I、III、IV、V\nD．I、II、III、IV、V",
            "answer": "A",
            "explain": "到期收益率的影响因素主要有以下四个：(1)票面利率。在其他因素相同的情况下，票面利率与债券到期收益率呈同方向增减。"
        },
        {
            "title": "衍生工具的要素包括（　　）。",
            "questions": "I．合约标的资产<br>II．到期日<br>III．交割价格<br>IV．结算",
            "question": "A．I、II、IV\nB．I、II、III\nC．I、II\nD．I、II、III、IV",
            "answer": "D",
            "explain": ""
        }, {
            "title": "普通客户者王在A证券公司买入股票，其股票将通过（　　）进行交收。",
            "question": "A．证券登记结算机构\nB．证券交易所\nC．A证券公司\nD．A证券公司委托证券登记结算机构",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "对于金融市场，以下事件中属于系统性风险的是（　　）。",
            "question": "A．由于受到几十年一遇异常冷水团影响，公司插种的虾夷扇贝绝收\nB．由于公司核算账户资金差错，造成货币资金多计29944309821.45元\nC．由于资金紧张，饲料供应不及时，公司生猪养殖死亡率高于预期\nD．物价水平普遍上涨，出现通货膨胀",
            "answer": "D",
            "explain": "非系统风险，是指发生于个别公司的特有事件造成的风险，纯粹由于个股自身的因素引起的个股价格变化以及由于这种变化导致的个股收益率的不确定性，因此只有物价上涨不属于个别公司的风险，它是系统性风险。系统性风险是由经济环境的变化引起的整个金融市场的不确定性增加，其冲击是全面的，主要包括经济增长、利率、汇率和通货膨胀，以及政治因素干扰等。故“物价水平普遍上涨，出现通货膨胀”属于系统性风险。"
        },
        {
            "title": "关于远期利率和即期利率，以下表述错误的是（　　）。",
            "question": "A．远期利率是制定和执行货币政策的参考工具\nB．即期利率可以预示市场对未来利率走势的期望\nC．成熟市场中几乎所有利率衍生品都依赖于远期利率\nD．现代金融分析中，远期利率有着非常广泛的应用",
            "answer": "B",
            "explain": "在现代金融分析中，远期利率有着非常广泛的应用。它可以是市场对未来利率走势的期望，也是中央银行指定和执行货币政策的参考工具。更重要的是，在成熟市场中几乎所有利率衍生品的定价都依赖于远期利率。"
        },
        {
            "title": "某上市公司上年实现的净利润为100万元，上年末每股市价为36元，普通股股东权益为250万元，流通在外的普通股股数为100万股，其中上年5月1日增发了20万股，9月1日回购了10万股，则上年末的市净率为（　　）。",
            "question": "A．15.84\nB．39.6\nC．14.4\nD．36",
            "answer": "C",
            "explain": "市净率=每股市价/每股净资产。每股净资产=普通股股东权益/流通在外普通股股数=250/100=2.5。市净率=36/2.5=14.4，故本题选C。"
        }, {
            "title": "适用于一家新成立的处于亏损阶段的未上市公司的相对较为合理的估值模型是（　　）。",
            "question": "A．市销率模型\nB．市盈率模型\nC．三阶段红利贴现模型\nD．股利贴现模型",
            "answer": "A",
            "explain": "市销率指标的引入主要是为克服市盈率等指标的局限性，在评估股票价值时需要对公司的收入质量进行评价。对于一些无利润甚至亏损的公司，经营性现金流也为负，且账面价值比较低的公司，都可以考虑采用市销率模型，与之相关不大的是贴现率的影响。"
        },
        {
            "title": "双方协议以某一信用工具为参考，一方向另一方出售信用保护，若信用工具发生违约事件，信用保护出售方必须向购买方支付赔偿，这样的互换合约被称为（　　）。",
            "question": "A．股权互换\nB．利率互换\nC．货币互换\nD．信用违约互换",
            "answer": "D",
            "explain": "双方协议以某一信用工具为参考，一方向另一方出售信用保护，若信用工具发生违约事件，信用保护出售方必须向购买方支付赔偿，这样的互换合约被称为信用违约互换。"
        },
        {
            "title": "以下选项中，不属于债券投资管理中常用免疫策略的是（　　）。",
            "question": "A．或有免疫策略\nB．所得免疫策略\nC．时间免疫策略\nD．价格免疫策略",
            "answer": "C",
            "explain": "常用的免疫策略主要包括：所得免疫、价格免疫和或有免疫。所得免疫策略保证投资者有充足的资金可以满足预期现金支付的需要。价格免疫由那些保证特定数量资产的市场价值高于特定数量负债的市场价值的策略组成。"
        },
        {
            "title": "关于计算VaR值的蒙特卡洛模拟法，下列描述错误的是（　　）。",
            "question": "A．蒙特卡洛模拟法计算量较大\nB．蒙特卡洛模拟法的局限性是VaR计算所选用的历史样本期间非常重要\nC．蒙特卡洛模拟法在估算之前，需要有风险因子的概率分布模型，继而重复模拟风险因子变动的过程\nD．蒙特卡洛模拟法被认为是最精准有效的计算VaR值的方法",
            "answer": "B",
            "explain": "最常用的VaR估算方法有参数法、历史模拟法和蒙特卡洛模拟法。1．参数法，参数法又叫方差协方差法。2．历史模拟法，历史模拟法简单，只需利用历史数据对未来进行估计，然而它也正是以风险因子的历史数据为VaR的数据源。历史模拟法也有局限性，即VaR所选用的历史样本期间非常重要。3．蒙特卡洛模拟法，蒙特卡洛模拟法在估算之前，需要有风险因子的概率分布模型，继而重复模拟风险因子变动的过程。"
        }, {
            "title": "以下各类股票估值方法中，不含相对价值法的选项是（　　）。",
            "question": "A．股利贴现模型，经济附加值模型，市销率模型\nB．股利贴现模型,企业价值倍数,市盈率模型\nC．股利贴现模型，经济附加值模型，自由现金流贴现模型\nD．股利贴现模型，企业价值倍数，经济附加值模型",
            "answer": "C",
            "explain": "相对价值法是适用一家上市公司的市盈率、市净率、市售率、市现率等指标与其竞争者进行对比，以决定该公司价值的方法。包括：市盈率、市净率、市销率、市现率以及企业价值倍数模型。"
        },
        {
            "title": "我国的证券登记结算机构是（　　）。",
            "question": "A．上海证券交易所和深圳证券交易所\nB．中国证券登记结算有限责任公司\nC．中国人民银行支付结算公司\nD．中国人民银行清算总中心",
            "answer": "B",
            "explain": "中国证券登记结算有限责任公司(简称中国结算公司)是我国的证券登记结算机构。"
        },
        {
            "title": "关于大宗商品投资，以下表述错误的是（　　）。",
            "question": "A．大宗商品投资可以采取购买大宗商品相关股票的方式\nB．大宗商品可以分为能源类、基础原材料、贵金属类和农产品类\nC．大宗商品具有抵御通货膨胀的功能\nD．大宗商品投资通常采用直接购买大宗商品实物的方式",
            "answer": "D",
            "explain": "大宗商品是指具有实体,可进入流通领域,但并非在零售环节进行销售,具有商品属性,用于工农业生产与消费使用的大批量买卖的物资商品。大宗商品具有同质化、可交易等特征，供需和交易量能非常大。分为四类:能源类，基础原材料类、贵金属类和农产品类，最典型的黄金是具有抗通胀属性的。"
        },
        {
            "title": "在我国早期证券市场中曾有一类投资者，对市场上的所有股票，每一只都少量购买甚至只买一手，业内将其称为股票集邮或者股票收藏投资者，这类投资者的投资方法体现了其分散投资和被动管理的策略，以下哪一类基金的出现，使这类投资者的想法得以更好的实现（　　）。",
            "question": "A．QFII基金\nB．QDII基金\nC．ETF基金\nD．股票型基金",
            "answer": "C",
            "explain": "ETF基金是以某一选定的指数所包含的成分证券（股票债券等）或商品为投资对象，依据构成指数的证券或商品的种类和比例，采取复制或者抽样复制，进行被动投资的指数基金。ETF不但具有传统指数基金的全部特点，而且是更为纯粹的指数基金。"
        },
        {
            "title": "关于远期合约，以下表述错误的是（　　）。",
            "question": "A．远期合约包含交割价格\nB．远期合约是标准化合约\nC．远期合约包含到期日\nD．远期合约包含合约标的资产",
            "answer": "B",
            "explain": "远期合约是一种非标准化的合约，即远期合约一般不在交易所进行交易，而是在金融机构之间或金融机构与客户之间通过谈判后签署的。在签署远期合约之前，双方可以就交割地点，到期日，交割价格、交易单位和合约标的资产的质量等细节进行谈判，以便尽量满足双方的需要。故“远期合约包含交割价格、到期日、合约标的资产”说法正确。"
        },
        {
            "title": "某QDII基金在未取得中国证监会的特别批准时进行了投资，下列选项符合相关规定的是（　　）。",
            "question": "A．临时借入现金，该现金金额占该QDII基金净值的15%\nB．购买香港某物业进行投资\nC．投资金融衍生品\nD．承销在港上市的某国有企业股票",
            "answer": "C",
            "explain": "除中国证监会另有规定外，QDII基金不得有下列行为：(1)购买不动产。(2)购买房地产抵押按揭。(3)购买贵重金属或代表贵重金属的凭证。(4)购买实物商品。(5)除应付赎回、交易清算等临时用途以外，借入现金。该临时用途借入现金的比例不得超过基金、集合计划资产净值的10%。(6)利用融资购买证券，但投资金融衍生产品除外。(7)参与未持有基础资产的卖空交易。(8)从事证券承销业务。(9)中国证监会禁止的其他行为。"
        },
        {
            "title": "关于各类资产估值价格的选取，以下表述错误的是（　　）。",
            "questions": "I．交易所上市交易的含权固定收益品种，按照当日收盘价作为估值全价<br>II．交易所上市的股船期货合约以估值当日收盘价进行估值<br>III．黄金ETF投资的黄金现货实盘合约按估值日金交所的当日估算价估值<br>IV．基金中基金投资的境内非货币市场基金，按基金中基金估值日的份额净值估值<br>V．交易所上市的资产支持证券品种和私券债券，按成本估值",
            "question": "A．I、III、IV、V\nB．II、III、IV\nC．I、II、III\nD．I、II、III、IV",
            "answer": "C",
            "explain": ""
        }, {
            "title": "关于房地产投资信托，以下表述错误的是（　　）。",
            "question": "A．房地产投资信托是证券化的房地产投资，可在交易市场上交易，具有较强的流动性\nB．与房地产公司股票相比，房地产投资信托的波动性更低\nC．房地产投资信托具有较大的通货膨胀风险，通货膨胀会带来严重的不利影响\nD．上市的房地产信托须定期进行信息披露，降低了信息不对称程度",
            "answer": "C",
            "explain": "房地产投资信托有以下特点：第一，流动性强，它是在交易市场上交易经过证券化的房地产，很容易进行房地产与现金之间的转换；第二，抵补通货膨胀效应，一般而言，房地产相关收入会与通货膨胀呈现同向变动的趋势，起到在通货膨胀时的保值功能；第三，风险较低，投资者可以利用资金投资于多种不同房地产种类，达到通过多样化分散风险的作用；第四，信息不对称程度低。"
        },
        {
            "title": "关于做市商，以下表述正确的是（　　）。",
            "question": "A．做市商在交易中执行投资者的指令，本身并不参与到交易中\nB．做市商是指令驱动市场中最为重要的角色\nC．做市商是报价驱动市场中最为重要的角色\nD．交易佣金通常是做市商主要的利润来源",
            "answer": "C",
            "explain": "做市商在报价驱动市场中处于关键性地位，他们在市场中与投资者进行买卖双向交易，经纪人则是在交易中执行投资者的指令，并没有参与到交易中，两者市场角色不同。此外，两者的利润来源不同——做市商的利润主要来自于证券买卖差，经纪人的利润则主要来自于给投资者提供经纪业务的佣金，对市场流动性的不同——在报价驱动市场中，做市商是市场流动性的主要提供者和维持者，而在指令驱动市场中，市场流动性是由投资者的指令提供的。"
        },
        {
            "title": "反映有效投资组合的风险与预期收益率之间均衡关系的方程式是（　　）。",
            "question": "A．证券市场线方程\nB．套利定价方程\nC．证券特征线方程\nD．资本市场线方程",
            "answer": "D",
            "explain": "本题考查证券市场线与资本市场线的区别。资本市场线给出了所有有效投资组合风险与预期收益率之间的关系，但没有指出每一个风险资产的风险与收益的关系，而证券市场线则给出每一个风险资产风险与预期收益率之间的关系。证券市场线用系统性风险（β值）衡量风险。资本市场线提供了衡量有效投资组合风险的方法。有效投资组合即是分布于资本市场线上的点，代表了有效前沿。特别是它指出了以标准差来表示的有效投资组合的风险，其与回报率之间是一种线性关系，因此以标准差来度量风险是更为合适的。资本市场线决定最适合的资产配置点。资本市场线的斜率是夏普比率。"
        },
        {
            "title": "关于优先股的权利，以下表述正确的是（　　）。",
            "questions": "I．具有剩余收益权<br>II．有优先的表决权<br>III．优于债券的清偿权<br>IV．具有股权和债权的双重特征",
            "question": "A．I、IV\nB．II、III\nC．III、IV\nD．I、II",
            "answer": "A",
            "explain": "优先股拥有股权和债权的双重属性；承诺付给持有人固定收入，但无表决权，具有剩余收益权；在公司盈利和剩余财产的分配顺序上，优先股股东先于普通股股东，但是债权人优先优先股东。"
        },
        {
            "title": "关于另类投资的优势，以下表述错误的是（　　）。",
            "question": "A．加入另类投资的多元的投资组合有可能得到比传统股票投资组合更高的收益\nB．另类投资波动性都远远低于股票市场\nC．投资者将另类投资纳入投资组合的目的是提高投资回报和分散风险\nD．许多另类投资的收益率与传统投资相关性较低",
            "answer": "B",
            "explain": "由于另类投资产品与传统证券投资产品具有较低的相关性，所以投资者能够通过另类投资产品达到分散投资风险的作用。在多元化投资组合中加入另类投资产品，有可能得到比传统股票和债券组合更高的收益和更低的波动性。"
        },
        {
            "title": "中国结算公司为买卖双方提供变更证券登记服务，并收取（　　）。",
            "question": "A．印花税\nB．过户费\nC．佣金\nD．经手费",
            "answer": "B",
            "explain": "佣金是投资者在委托买卖证券成交后按成交金额一定比例支付的费用，是证券经纪商为客户提供证券代理买卖服务收取的费用。经手费是证券交易所手续费，监管费是证券交易所交易监管费。过户费是委托买卖的股票、基金成交后，买卖双方为变更证券登记所支付的费用。这笔收入属于中国结算公司的收入，由证券经纪商在同投资者清算交收时代为扣收。2008年9月4日，证券交易印花税只对出让方按0.1%征收，对受让方不再征收。"
        }, {
            "title": "基金公司投资交易过程中，监控组合投资交易情况的部门有（　　）。",
            "questions": "I．基金经理及投资总监<br>II．法律督察部<br>III．风险管理部<br>IV．交易管理部",
            "question": "A．I、II、IV\nB．II、III\nC．I、II\nD．I、II、III、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "银行间债券市场的债券结算过程中，如果采用以下（　　）类型结算，其中某个参与者无法进行结算，会给整个市场带来较大的系统性风险。",
            "question": "A．全额结算\nB．双边结算\nC．净额结算\nD．逐笔结算",
            "answer": "C",
            "explain": "净额结算是指结算系统在设定的时间段内，对市场参与者债券买卖的净差额和资金净差额进行交收。净额结算在指定时间段内只有一个结算净额，从而降低了市场参与者的流动性需求，结算成本和相关风险，也提高了市场参与者尤其是做市商投资运用和市场动作的效率。但同时净额结算实际上是一个交易链，要求指定时间段内所有的结算着顺利进行，如果有某个参与者无法进行结算，则会对其他参与者的结算带来影响，甚至"
        },
        {
            "title": "资料：某机构投资者等比例持有F、JRDH基金，其中，F、J股票基金的平均年化收益率为15%和8%，系统风险B分别为1.2和0.6；H为债券基金，平均年化收益率为4%，久期为3年。假设通货膨胀比较严重，预期政府将加息，并将导致货币供给案缩，股市短期内资金面紧张，如果投资组合资金能在上述三只基金内进行比例调整，且保持股票和债券基金的总体比例不变，那么理论上以下表述正确的是（　　）。",
            "question": "A．降低F股票基金的占比，建议H债券基金降低久期\nB．提高F股票基金的占比，建议H债券基金的加长久期\nC．提高F股票基金的占比，建议H债券基金降低久期\nD．降低F股票基金的占比，建议H债券基金的加长久期",
            "answer": "A",
            "explain": "政府预期加息，将导致股票和债券价格下跌，β系数为1.2，代表市场下跌1%，F股票基金下跌1.2%，为了防范风险，应该降低B较大的F股票基金"
        },
        {
            "title": "关于交易成本，以下表述错误的是（　　）。",
            "question": "A．证券公司对不同的投资者往往采取不同的交易佣金率\nB．印花税是隐性交易成本\nC．证券交易经手费是证券交易所征收的费用\nD．调整印花税是调整市场活跃度手段之一",
            "answer": "B",
            "explain": "显性成本（直接成本或价外成本）是不包含在交易价格以内的费用支出，按照收费主体划分，包含经纪商佣金、税费、交易所规费/结算所规费三个主要部分，包括我国证券交易所向投资者收取证券交易经手费、监管费和印花税；证券交易结束后还需要支付给证券登记结算机构一定费用，这部分费用称为过户费；交易技术供应商的收费等。"
        },
        {
            "title": "关于基金业绩评价，以下表述错误的是（　　）。",
            "question": "A．同一基金在不同时间区间内的表现差距可能也很大\nB．需要考虑基金的规模\nC．不同基金在不同时间区间内的收益，风险不同可比性\nD．风险调整前的收益比风险调整后的超额收益更加重要",
            "answer": "D",
            "explain": "系统的基金业绩评估需要从两个方面入手：计算绝对收益，计算风险调整后收益，计算相对收益，进行业绩归因。所以风险调整后的超额收益比风险调整前的收益更加重要。"
        },
        {
            "title": "以下不属于货币市场工具的是（　　）。",
            "question": "A．定期存款\nB．资产支持证券\nC．央票\nD．银行间回购协议",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "下行风险是指由于市场环境变化，未来价格走势有可能比投资者所预期的目标价位（　　）。",
            "question": "A．低\nB．高\nC．更具不确定性\nD．不变",
            "answer": "A",
            "explain": "下行标准差关注收益率低于目标的风险。通常需要对下行标准差进行年化处理，如果收益率采用每日收益则乘以交易日数量的开方，如果采用每月收益，则乘以12的开方。"
        }, {
            "title": "关于可转债投资的风险，以下表述正确的是（　　）。",
            "questions": "I．持有者不用承担股价波动的风险<br>II．投资者不会有利率损失风险<br>III．可转债规定发行者可以在发行一段时间后以某一价格赎回债券，因而投资者要承担再投资风险<br>IV．我国可转债的部分品种具有强制性转股条款，这将给投资者带来转换风险",
            "question": "A．III、IV\nB．I、II\nC．I、III、IV\nD．I、II、III",
            "answer": "A",
            "explain": "可转债投资的风险主要有以下四点："
        },
        {
            "title": "某基金年度收益为20%，同期其业绩比较基准的收益为15%，沪深300指数的收益为17%，则该基金相对其比较基准的超额收益为（　　）。",
            "question": "A．-0.05\nB．-0.03\nC．0.05\nD．0.03",
            "answer": "C",
            "explain": "基金的相对收益，又叫超额收益，代表一定时间区间内，基金收益超出业绩比较基准的部分，可以是负值，也可以是正值，相对收益=真实收益率-基准收益率=基金收益率-业绩比较基准收益率=20%-15%=5%。"
        },
        {
            "title": "在95%的置信水平下，某投资组合的VAR值在概率分布图中-10%分位的位置，则该投资组合的预期损失为（　　）。",
            "question": "A．-10%左侧区域内所有损失的期望值\nB．-0.05\nC．-0.1\nD．-5%左侧区域内所有损失的期望值",
            "answer": "A",
            "explain": "预期损失是指在给定时间区间和置信区间内，投资组合损失的期望值，也称作条件风险价值或条件尾部期望或尾部损失。与VaR值的最大不同点是，VaR值就是一个分位值，也就是说投资组合有95%的可能损失最大不会超过10%，如果概率超过95%的话，就需要用预期损失来衡量，即在VaR值左侧所有损失的期望值。"
        },
        {
            "title": "某永续债每年付息一次，每次5元，如市场利率为5%，则该债券的内在价值为（　　）元。",
            "question": "A．110\nB．105\nC．100\nD．95",
            "answer": "C",
            "explain": "永续债券相当于统一公债，都是一种没有到期日的特殊债券，最典型的是英格兰银行在18世纪发行的英国统一公债。统一公债或者永续债公式：V=C/r=年利息/市场利率，所以永续债的内在价值=5/5%=100元。"
        },
        {
            "title": "根据2017年9月5日，证监会发布《中国证监会关于证券投资基金估值业务的指导意见》，其中关于基金管理人的估值技术的表述错误",
            "question": "A．基金管理人改变估值技术时，应当在定期报告中披露\nB．基金管理人应当明确基金估值的程序和技术\nC．基金管理人改变估值技术时，应当本着最大限度保护投资者利益的原则及时进行临时公告\nD．基金管理人改变估值技术之前必须咨询会计师事务所的专业意见",
            "answer": "D",
            "explain": "为确保估值程序和技术的持续适用性，基金管理人应建立定期复核和审阅机制，以确保相关估值程序和技术不存在重大缺陷。当改变或基金资产净值的变化在0.25%以上的，基金管理人应就所采用的相关估值技术、假设及输入值的适当性等咨询会计师事务所的专业意见。"
        },
        {
            "title": "关于股票基金投资组合构建和业绩比较基准的选择，以下表述错误的是（　　）。",
            "question": "A．指数型股票基金不以获得超过业绩比较基准的收益率为目标\nB．若基金合同规定了投资的行业和风格，则基金投资范围将受到较为严格的限制\nC．股票基金选择单一的股票指数作为业绩比较基准，不同风格的基金选择不同的股票指数\nD．主动型股票基金在选择业绩比较基准时，需要充分考虑基金投资目标和风格的影响",
            "answer": "C",
            "explain": "实际操作中一般根据投资范围和投资目标选取基准指数，可以是全市场指数，风格指数，也可以是由不同指数复合而成的复合指数。如果一个基金的目标是投资特定市场或特定行业，就可以选取该市场或行业指数，如以创业板指数或医药生物行业指数作为业绩比较基准。此外，也可以选取几个指数的组合作为一个基金的业绩比较基准。"
        }, {
            "title": "相比于股票投资组合，债券投资组合构建时需考虑的特有因素包括（　　）。",
            "questions": "I．期限结构<br>II．标的公司的经营状况<br>III．宏观经济<br>IV．组合久期",
            "question": "A．III、IV\nB．II、III\nC．I、II\nD．I、IV",
            "answer": "D",
            "explain": "股票投资组合与债券投资组合有着明显的区别，债券投资组合构建除了考虑基本因素外，还需要考虑信用结构、期限结构、组合久期、流动性和杠杆率等因素。"
        },
        {
            "title": "关于我国不同类型证券的投票权，以下表述正确的是（　　）。",
            "question": "A．债券的投票权仅次于普通股\nB．优先股有优先投票权\nC．投票权与现金流量权保持一致\nD．普通股按持股比例投票",
            "answer": "D",
            "explain": "债券的债权人没有投票权，优先股一般不享有投票权，普通股按照持股比例投票。一般投票权和现金流量权是不一致的。"
        },
        {
            "title": "相关系数在金融市场上的应用不包括（　　）。",
            "question": "A．组合整体表现与市场组合收益的数量关系\nB．利用期货与现货资产价格的相关性实现套期保值\nC．分析持有的投资组合内各项证券价格的联动性\nD．分析按不同比例配置资产构造投资组合的总体期望收益率",
            "answer": "D",
            "explain": "在金融市场上，我们时常想要知道多个不同随机变量之间的联系，比如利用期货与现货资产价格的相关性实现套期保值；再比如分析持有的投资组合内各项证券的价格联动性，以及组合整体表现与市场组合收益的数量关系等。"
        },
        {
            "title": "关于投资者的投资目标，以下表述错误的是（　　）。",
            "question": "A．承担风险的意愿是投资者的主观意愿，反映了投资者的风险厌恶程度\nB．承担风险的能力由投资者的各项客观因素决定\nC．如果投资者的资产大于负债，或者收入远远大于日常支出，那么可以认为该投资者具有较高的风险承受能力\nD．如果投资者持有的资产投资期限短，那么可以认为该投资者具有较高的风险承受能力",
            "answer": "D",
            "explain": "承担风险的能力由投资者自身的投资期限、收入支出状况和资产负债状况等客观因素决定。其他条件相同的条件下，相比投资期限较短的投资者而言，投资期限较长的投资者具有更高的风险承受能力。这是因为如果投资期限较长，那么投资者就有更长的时间来调整自己的投资组合构成状况以弥补投资损失，比如提高储蓄率和提高无风险资产在投资组合中所占比重，或者等待市场好转。同样，如果投资者的资产远远大于负债，或者"
        },
        {
            "title": "主动投资的目标是（　　）。",
            "question": "A．扩大主动收益、缩小系统性风险、降低夏普比率\nB．扩大主动收益、缩小主动风险、降低信息比率\nC．扩大主动收益、缩小系统性风险、提高夏普比率\nD．扩大主动收益、缩小主动风险、提高信息比率",
            "answer": "D",
            "explain": "主动投资的目标是扩大主动收益、缩小主动风险、提高信息比率。"
        },
        {
            "title": "以下常见的股票市场指数中，采用算数平均法编制而成的是（　　）。",
            "question": "A．标普500\nB．沪深300\nC．上证指数\nD．道琼斯指数",
            "answer": "D",
            "explain": "标准普尔500指数采用加权平均法进行计算，以股票上市量为权数，按基期进行加权计算。沪深300指数运用派氏加权编制而成。道琼斯股票价格指数最早在1884年由道琼斯公司的创始人查尔斯开始编制，是一种算数平均股价指数。上证指数系列均采用派氏加权综合价格指数公式计算而成。"
        },
        {
            "title": "股票A目前市场价格为每股9元，投资者预期股票A价格将下跌，计划购买执行价格为每股8元、两周后到期的相应看跌期权获利，则投资者购买权为（　　）。",
            "question": "A．虚值期权，期权费等于0\nB．实值期权，期权费等于1\nC．虚值期权，期权费大于0\nD．实值期权，期权费大于1",
            "answer": "C",
            "explain": "本题中执行价格为8元，市场价格为9元，看跌期权执行价格低于市场价格则为虚值期权，此时行权现金流为负，而期权费任何时间均应该大于0因为期权费是购买期权付出的成本。"
        }, {
            "title": "关于每日进行收益分配的固定净值的普通货币市场基金，以下表述错误的是（　　）。",
            "question": "A．基金份额净值始终等于面值\nB．红利再投资将待分配净利润按照基金份额面值折算为基金份额\nC．红利再投资形成的份额也享有基金的分配权益\nD．基金份额净值可能超过面值",
            "answer": "D",
            "explain": "普通货币市场基金均为固定净值1元，基金份额净值始终等于面值，变动的是基金份额。"
        },
        {
            "title": "关于互换合约，以下表述错误的是（　　）。",
            "question": "A．利率互换合约是指两种不同利率的货币之间交换合约，一般伴随本金交换\nB．互换合约通常交换的是具有相等经济价值的现金流的合约\nC．互换合约是交易双方约定未来某一时期相互交换某种合约标的资产的合约\nD．互换通常采用非标准化形式在场外交易",
            "answer": "A",
            "explain": "互换合约是指交易双方约定在未来某一时期相互交换某种合约标的资产的合约。更为准确地说，互换合约是指交易双方之间约定的在未来某一期日内交换他们认为具有相等经济价值的现金流的合约。互换通常采用非标准化形式在场外交易。"
        },
        {
            "title": "可转换债券简称可转债，是指在一段时期内，持有者有权按照约定的转换价格或转换比率将其转换为（　　）的公司债券。",
            "question": "A．有限售期的普通股股票\nB．普通股票\nC．标的股票的衍生品\nD．优先股股票",
            "answer": "B",
            "explain": "可转换债券是债券持有人可按照发行时约定的价格将债券转换成公司的普通股票的债券。如果债券持有人不想转换，则可以继续持有债券，直到偿还期满时收取本金和利息，或者在流通市场出售变现。如果持有人看好发债公司股票增值潜力，在宽限期之后可以行使转换权。按照预定转换价格将债券转换成为股票，发债公司不得拒绝。"
        },
        {
            "title": "甲、乙两家企业的资产收益率均为10%，甲的资产负债率高于乙，乙的总资产周转率高于甲，以下表述正确的是（　　）。",
            "question": "A．甲的净资产收益率低于乙，乙的销售利润率低于甲\nB．甲的净资产收益率低于乙，乙的销售利润率高于甲\nC．甲的净资产收益率高于乙，乙的销售利润率低于甲\nD．甲的净资产收益率高于乙，乙的销售利润率高于甲",
            "answer": "C",
            "explain": "总资产收益率=销售利润率×总资产周转率，甲、乙总资产收益率相等，乙的总资产周转率高于甲，则乙的销售利润率低于甲。净资产收益率=总资产收益率×权益乘数=总资产收益率×1/(1-资产负债率)，甲、乙的总资产收益率相同，甲的资产负债率高于乙，则甲的净资产收益率低于乙。"
        },
        {
            "title": "2018年6月12日某投资者以5元买入A股票1000股，并以20元价格卖出B股票5000股，该投资者缴纳的印花税为（　　）元。",
            "question": "A．210\nB．100\nC．105\nD．200",
            "answer": "B",
            "explain": "目前，我国A股印花税税率为单边征收（只在卖出股票时征收），税率为0.1%，对于基金卖出股票时按照千分之一征收印花税。而对买入交易不再征收印花税，即对印花税实行单向征收。只有“以20元价格卖出B股票5000股”需要缴纳印花税=20*5000*0.1%=100元。"
        },
        {
            "title": "一般来说，如按跟踪误差大小依次递减排列，三种指数复制方法的排列次序很可能是（　　）。",
            "question": "A．优化复制、完全复制、抽样复制\nB．完全复制、优化复制、抽样复制\nC．完全复制、抽样复制、优化复制\nD．优化复制、抽样复制、完全复制",
            "answer": "D",
            "explain": "根据市场条件的不同，通常有三种指数复制方法，即完全复制、抽样复制和优化复制，三种复制方法所使用的样本股票的数量依次递减，但是跟踪误差依次增加。"
        },
        {
            "title": "关于基金利润分配，以下表述正确的是（　　）。",
            "question": "A．基金进行利润分配，拟分配利润必须全部以现金方式支付\nB．封闭式基金进行利润分配，投资者可以选择分红再投资方式\nC．基金进行利润分配会导致基金份额净值的下降，但对投资者利益没有实际影响，分配前应当发布分红公告\nD．基金进行利润分配后，份额净值可能低于面值",
            "answer": "C",
            "explain": "基金分红的原则：基金当期收益先弥补上期亏损后，方可进行当期收益分配；基金收益分配后每份基金份额的净值不能低于面值；如果基金当期出现亏损，则不进行收益分配。有的基金还在招募说明书中对基金收益的分派事先作了约定，如一年中最少、最多的分派次数，或当可分配收益达到一定标准就进行分红等。"
        },
        {
            "title": "某基金管理公司管理的基金A，在T日发生了估值计价错误，将T日每份100.00元误估为100.2元，该基金公司发现后，应当（　　）。",
            "questions": "I．对基金份额持有人造成损失的，应该承担赔偿责任<br>II．及时向中国证监会报告<br>III．因紧急事项暂停估值<br>IV．调查计价错误是否由基金托管人造成，如是则追究相应责任",
            "question": "A．I、IV\nB．I、III、IV\nC．I、II、IV\nD．I、II",
            "answer": "A",
            "explain": "基金管理公司在发现估值错误后，应及时向中国证监会报告，并调查计价错误是否由基金托管人造成，如是则追究相应责任。"
        }, {
            "title": "通常而言，收益率曲线的正常形态是（　　）。",
            "question": "A．水平曲线\nB．下降曲线\nC．上升曲线\nD．垂直曲线",
            "answer": "C",
            "explain": "收益率曲线是显示一组货币和信贷风险均相同，但期限不同的债券或其他金融工具收益率的图表。纵轴代表收益率，横轴则是距离到期的时间。通常而言，收益率曲线的正常形态是向上倾斜的曲线，还有水平曲线、下降曲线以及拱形曲线等等。"
        },
        {
            "title": "关于期货市场的价格发现功能的存在条件，以下表述错误的是（　　）。",
            "question": "A．期货和现货市场之间不存在套利活动\nB．通过期货交易者对资产组合的调整，期货价格能更好的反映未来市场的变化\nC．期货市场存在大批专业化于信息收集和分析的投机者\nD．研究表明期货市场的交易者具有更好的信息，并能将信息传递给现货市场的交易者",
            "answer": "A",
            "explain": "在市场经济条件下，价格是根据市场供求状况形成的。期货市场上来自各个地方的交易者带来了大量的供求信息，标准化合约的转让又增加了市场流动性，期货市场中形成的价格能真实地反映供求状况，同时又为现货市场提供了参考价格，起到了“价格发现”的功能。研究表明，期"
        },
        {
            "title": "关于资产负债表中的信息，下列选项表述均错误的是（　　）。",
            "questions": "I．包含了企业占有资源的数量和性质<br>II．资产项揭示了企业资金的资金来源和财务状况<br>III．表中的信息为分析收入来源性质及稳定性提供了基础，可以为收益把关<br>IV．只要研究负债项即可了解企业短期及长期偿债能力",
            "question": "A．II、IV\nB．II、III、IV\nC．III、IV\nD．I、II、III",
            "answer": "A",
            "explain": "通过分析企业的资产负债表，能够揭示出企业资产要素的信息、长期或短期的还债务能力、资本结构是否合理、企业经营稳健与否或经营风险的大小以及股东权益结构状况等。资产负债表有四大作用："
        },
        {
            "title": "按计息方式分类，债券可分为（　　）。",
            "question": "A．固定利率债券、浮动利率债券、零息债券\nB．息票债券、贴现债券\nC．息票债券、零息债券\nD．固定利率债券、浮动利率债券、通胀联结债券",
            "answer": "A",
            "explain": "按计息方式分类，债券可分为固定利率债券、浮动利率债券、零息债券等。"
        },
        {
            "title": "完整表述了强有效证券市场的说法是（　　）。",
            "question": "A．证券价格充分反映了所有历史信息\nB．证券价格充分反映了所有历史信息和公开发布的信息\nC．证券价格充分反映了所有未公开发布的内部信息\nD．证券价格充分反映了所有公开发布的信息和未公开发布的内部信息",
            "answer": "D",
            "explain": "有效市场是指证券价格能够充分反映价格历史序列中包含的所有信息。如果这些历史信息对证券价格的变动不会产生任何影响，则意味着证券市场达到了弱有效，这说明这些历史信息已经被投资者充分消化利用并反映到了证券价格上。因此在一个有效的证券市场上，任何预测未来证券价格走势而对以往价格、交易量等历史信息所进行的技术分析都是徒劳。"
        },
        {
            "title": "以下风险属于非系统性风险的有（　　）。",
            "questions": "I．财务风险<br>II．经营风险<br>III．流动性风险<br>IV．政治风险",
            "question": "A．I、II、III、IV\nB．I、II、IV\nC．II、III、IV\nD．I、II、III",
            "answer": "D",
            "explain": "非系统性风险是指发生于个别公司的特有事件造成的风险，纯粹由于个股自身的因素引起的个股价格变化以及由于这种变化导致的个股收益率的不确定性，因此只有政治风险属于系统性风险，而财务风险、经营风险和流动性风险属于非系统性风险。"
        }, {
            "title": "下列选项中，会带来跨境投资估值风险的是（　　）。",
            "questions": "I．跨境业务涉及多市场、多品种和多币种的估值核算<br>II．数据来源不一致<br>III．证券交易过度活跃<br>IV．各国税收制度不一样",
            "question": "A．I、II、IV\nB．I、II、III\nC．II、III、IV\nD．I、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "银行间债券市场的见款付券结算方式，允许付款方资金延迟到账，即结算宽限期，具体时间为（　　）。",
            "question": "A．指定结算日当天收市前\nB．指定结算日后的次一营业日\nC．付券方办理债券交割日\nD．付券方同意的资金到账日期",
            "answer": "B",
            "explain": "见款付券，简称DAP，指付券方确定收到收券方应付款项后予以确认，要求中央结算公司办理债券交割的结算方式。这是一种对券方有利的结算方式，有利于付券方控制风险，但收券方会有一个风险敞口，该方式在收券方对付券方比较信赖的情况下可以采用。采用见款付券方式往往是付券方信用比收券方要好。在见款付券结算方式下，由于付款方资金可能会出现银行资金在途的时间，因此允许结算资金有一个延迟到账的期限。"
        },
        {
            "title": "某汽车生产企业在2017年度收到一笔订购汽车的预收账款，共计现金5000万元，这笔预收账款对该企业现金流的影响是（　　）。",
            "question": "A．企业的现金流增加但不影响现金流量表\nB．投资活动产生的现金流增加\nC．筹资活动产生的现金流减少\nD．经营活动产生的现金流增加",
            "answer": "D",
            "explain": "与企业生产经营活动相关的现金流属于经营活动现金流，与投资活动相关的现金流属于投资活动现金流，与筹资活动相关的现金流属于筹资活动现金流。汽车企业销售汽车属于经营活动，所以收到汽车的预收账款会增加经营活动现金流。当企业的资产增加时，相关经营活动现金流减少，负债增加时，相关经营活动现金流增加，可以以此来判断现金流情况，由于预收账款属于负债，所以负债的增加会导致经营活动现金流增加。"
        },
        {
            "title": "以下选项中，不能用于防范债券基金流动性风险的有（　　）。",
            "question": "A．准备一定的现金以备不时之需\nB．增加长久期债券配置比例\nC．选择交易活跃的债券\nD．控制流通受限资产比例",
            "answer": "B",
            "explain": "基金公司流动性风险管理的主要措施包括：（1）少选择交易不活跃的债券，故“控制流通受限资产比例”“选择交易活跃的债券”正确。（2）避免债券到期日过于集中。（3）分析投资组合持有人结构和特征，关注投资者申赎意愿。（4）准备一定的现金。"
        },
        {
            "title": "关于投资债券的风险，以下表述错误的是（　　）。",
            "question": "A．对于浮动利率债券，在利率下行的环境中具有较低的利率风险\nB．投资通货膨胀联结债券可以避免通货膨胀风险\nC．投资可赎回债券可能会面临再投资风险\nD．交易不活跃的债券通常有较大的流动性风险",
            "answer": "A",
            "explain": "本题考查投资债券的风险。（1）利率风险：指利率变动引起债券价格波动的风险。债券的价格与利率呈反向变动关系：利率上升时，债券价格下降；而当利率下降时，债券价格上升。这种风险对固定利率债券和零息债券来说特别重要，而浮动利率债券的利息在支付日根据当前市场利率重新设定，从而在市场利率上升的环境中，债券票息率浮动上升，具有较低的利率风险，而在市场利率下行的环境中，债券票息率浮动下降，具有较高的利率风险，故“对于浮动利率债券，在利率下行的环境中具有较低的利率风险”错误。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/jjjc-3.js